export interface ServiceWorkerConfig {
  enabled: boolean;
  cacheEnabled: boolean;
  cacheName: string;
  urlsToCache: string[];
  updateInterval: number;
  skipWaiting: boolean;
  clientsClaim: boolean;
}

const config: ServiceWorkerConfig = {
  enabled: process.env.NODE_ENV === 'production',
  cacheEnabled: process.env.NODE_ENV === 'production',
  cacheName: 'vue-template-v1',
  urlsToCache: [
    '/portal/',
    '/portal/index.html',
    '/portal/manifest.json',
    '/portal/icons/comp-logo.png',
    '/portal/icons/apple-touch-icon.png',
    '/portal/icons/web-app-manifest-192x192.png',
    '/portal/icons/web-app-manifest-512x512.png'
  ],
  updateInterval: 60 * 60 * 1000, // 1 hour
  skipWaiting: true,
  clientsClaim: true
};

export default config; 